function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Sales_x5F_of_x5F_electric_x5F_heat_x5F_gas_x5F_01"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: "14",
  strokeMiterlimit: "10",
  d: "M106.3 153.3v87.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.1 141.7v10c0 14.5 11.9 26.4 26.4 26.4h4.1c14.3 0 25.9-11.6 25.9-25.9v-10.6H78.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M114.8 121.9h11.1v22.3h-11.1zM86.7 122h11.1v27.8H86.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st2"] || "st2",
  d: "M156.1 150.1c0-12.2 9.5-22.1 21.2-22.1s21.2 9.9 21.2 22.1v61.7c0 12.2-9.5 22.1-21.2 22.1s-21.2-9.9-21.2-22.1v-61.7zM151.8 206.5h25.1M151.8 154.1h25.1M151.9 180.1H177"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 0H35.4v283.5H248V92.1L141.7 0zm14.2 49.8L188.4 78h-32.5V49.8zM63.8 255.1V28.3h63.8v78h92.1v148.8H63.8z"
}))));